import { useEffect, useState } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';

const NAV_LINKS = [
  { to: '/', label: '首页' },
  { to: '/category/rexue', label: '热血' },
  { to: '/category/gaoxiao', label: '搞笑' },
  { to: '/category/shaonv', label: '少女漫' },
  { to: '/category/shaonian', label: '少年漫' },
  { to: '/category/wanjie', label: '完结' },
  { to: '/category/hanzu', label: '汉化组' },
  { to: '/about', label: '关于我们' },
  { to: '/faq', label: '常见问题' },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [keyword, setKeyword] = useState('');
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (!keyword.trim()) return;
    navigate(`/?q=${encodeURIComponent(keyword.trim())}`);
    setKeyword('');
    setOpen(false);
  };

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b transition-all duration-300 ${
        scrolled
          ? 'border-background-200 bg-background-50/95 shadow-sm backdrop-blur'
          : 'border-transparent bg-background-50'
      }`}
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6">
        <Link to="/" className="flex shrink-0 items-center gap-2" aria-label="免费51漫画 首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-lg font-black text-background-50">
            51
          </span>
          <span className="font-heading text-lg font-black tracking-tight text-foreground-950">
            免费<span className="text-primary-600">51漫画</span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
          {NAV_LINKS.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              end={link.to === '/'}
              className={({ isActive }) =>
                `whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                  isActive
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-700 hover:bg-secondary-100 hover:text-foreground-950'
                }`
              }
            >
              {link.label}
            </NavLink>
          ))}
        </nav>

        <form onSubmit={handleSearch} className="hidden items-center xl:flex">
          <label className="sr-only" htmlFor="site-search">搜索漫画</label>
          <div className="flex h-10 items-center rounded-full border border-background-200 bg-background-100 px-3 focus-within:border-primary-400">
            <i className="ri-search-line mr-2 text-sm text-foreground-600"></i>
            <input
              id="site-search"
              type="search"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索漫画 / 作者 / 类型"
              className="w-44 bg-transparent text-sm text-foreground-900 placeholder:text-foreground-500 focus:outline-none"
            />
            <button
              type="submit"
              className="ml-2 whitespace-nowrap rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              搜索
            </button>
          </div>
        </form>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-lg border border-background-200 text-foreground-800 lg:hidden"
          aria-label={open ? '关闭菜单' : '打开菜单'}
          aria-expanded={open}
        >
          <i className={`text-lg ${open ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 lg:hidden">
          <form onSubmit={handleSearch} className="mb-3 flex items-center xl:hidden">
            <div className="flex h-10 flex-1 items-center rounded-full border border-background-200 bg-background-100 px-3">
              <i className="ri-search-line mr-2 text-sm text-foreground-600"></i>
              <input
                type="search"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索漫画"
                className="w-full bg-transparent text-sm text-foreground-900 focus:outline-none"
              />
            </div>
            <button
              type="submit"
              className="ml-2 whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm font-medium text-background-50"
            >
              搜索
            </button>
          </form>
          <nav className="grid grid-cols-2 gap-1" aria-label="移动端导航">
            {NAV_LINKS.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                end={link.to === '/'}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `rounded-lg px-3 py-2 text-sm font-medium ${
                    isActive ? 'bg-primary-100 text-primary-700' : 'text-foreground-700 hover:bg-secondary-100'
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}